module.exports = __webpack_public_path__ + "telegram.svg?be972cb292f25f7f4369068c3207f681";


//////////////////
// WEBPACK FOOTER
// ./Content/src/assets/MyProgress/telegram.svg
// module id = 868
// module chunks = 1